import React, { useEffect, useState } from "react";
import ExamPills from "../component/ExamPills";
import BC from "../component/Breadcrumb";
import SB from "../component/SearchBox";
import Bdg from "../component/Badge";
import I from "../component/Icon";
import apiService from "../services/apiService";


const TEACHER_BY_ID_API =
  "Teacher/getTeacherById";

const normalizeTeacher = (data = {}, fallback = {}) => {
  const merged = { ...fallback, ...data };

  const id =
    merged?.id ??
    merged?.Id ??
    merged?.teacherId ??
    merged?.TeacherId;

  const schoolId =
    merged?.schoolId ??
    merged?.SchoolId ??
    fallback?.schoolId ??
    fallback?.SchoolId;

  const name =
    merged?.name ??
    merged?.Name ??
    fallback?.name ??
    fallback?.Name ??
    "";

  const isActive =
    merged?.isActive ??
    merged?.IsActive ??
    (String(merged?.status ?? fallback?.status ?? "")
      .toLowerCase() === "active");

  return {
    ...merged,
    id,
    schoolId,
    name,
    school:
      merged?.school ??
      merged?.School ??
      merged?.schoolName ??
      merged?.SchoolName ??
      fallback?.school ??
      fallback?.School ??
      "",
    mobile:
      merged?.mobile ?? merged?.Mobile ?? "",
    alternatePhone:
      merged?.alternatePhone ??
      merged?.AlternatePhone ??
      "",
    email:
      merged?.email ?? merged?.Email ?? "",
    address:
      merged?.address ?? merged?.Address ?? "",
    pincode:
      merged?.pincode ?? merged?.Pincode ?? "",
    dob:
      merged?.dob ?? merged?.DOB ?? "",
    gender:
      merged?.gender ?? merged?.Gender ?? "",
    isActive: Boolean(isActive),
    status: isActive ? "active" : "inactive",
    initials:
      merged?.initials ??
      merged?.Initials ??
      (name || "T")
        .split(" ")
        .filter(Boolean)
        .map((word) => word[0])
        .join("")
        .slice(0, 2)
        .toUpperCase(),
    studentCount:
      merged?.studentCount ??
      merged?.StudentCount ??
      fallback?.studentCount ??
      fallback?.StudentCount ??
      0,
    booksPurchased:
      merged?.booksPurchased ??
      merged?.BooksPurchased ??
      fallback?.booksPurchased ??
      fallback?.BooksPurchased ??
      0,
    examNames:
      merged?.examNames ??
      merged?.ExamNames ??
      fallback?.examNames ??
      fallback?.ExamNames ??
      [],
  };
};

export default function TeacherView({
  teacher,
  students,
  onBack,
  onEdit,
}) {
  const [tab, setTab] = useState("students");
  const [q, setQ] = useState("");
  const [statusF, setStatusF] = useState("All");
  const [examF, setExamF] = useState("All");

  const [teacherData, setTeacherData] = useState(() =>
    normalizeTeacher({}, teacher || {})
  );
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailError, setDetailError] = useState("");

  const teacherId =
    teacher?.id ??
    teacher?.Id ??
    teacher?.teacherId ??
    teacher?.TeacherId;

  useEffect(() => {
    setTeacherData(
      normalizeTeacher({}, teacher || {})
    );

    if (!teacherId) {
      setDetailError("Teacher id not found.");
      return;
    }

    const loadTeacher = async () => {
      try {
        setDetailLoading(true);
        setDetailError("");

        const response = await apiService.get(
          `${TEACHER_BY_ID_API}/${teacherId}`
        );

        const result = response.data;

        console.log(
          "Get Teacher By Id Response:",
          result
        );

        if (
          result?.isSuccess === false ||
          result?.IsSuccess === false
        ) {
          throw new Error(
            result?.failureReason ??
            result?.FailureReason ??
            result?.message ??
            result?.Message ??
            "Failed to load teacher details"
          );
        }

        const output =
          result?.output ??
          result?.Output ??
          result?.data ??
          result?.Data ??
          result;

        const teacherResult =
          output?.result ??
          output?.Result ??
          output;

        setTeacherData(
          normalizeTeacher(
            teacherResult,
            teacher || {}
          )
        );
      } catch (error) {
        console.error(
          "Get teacher by id error:",
          error
        );

        console.log(
          "Backend Error Response:",
          error?.response?.data
        );

        const apiError =
          error?.response?.data;

        setDetailError(
          apiError?.message ||
          apiError?.Message ||
          apiError?.failureReason ||
          apiError?.FailureReason ||
          error?.message ||
          "Failed to load teacher details"
        );
      } finally {
        setDetailLoading(false);
      }
    };

    loadTeacher();
  }, [teacherId]);

  const viewTeacher = teacherData || {};
  const studentList = Array.isArray(students)
    ? students
    : [];
  const ITEMS_PER_PAGE = 5;

  const [studentPage, setStudentPage] = useState(1);
  const [bookPage, setBookPage] = useState(1);

  const myStudents = studentList.filter(
    (s) => s.schoolId === viewTeacher.schoolId
  );

  const filtStudents = myStudents.filter((s) => {
    const mQ = [s.name, s.roll]
      .join(" ")
      .toLowerCase()
      .includes(q.toLowerCase());

    const mS =
      statusF === "All" ||
      s.status === statusF.toLowerCase();

    const mE =
      examF === "All" ||
      (s.exams || []).includes(examF);

    return mQ && mS && mE;
  });

  const studentExams = [
    "All",
    ...new Set(
      myStudents.flatMap((s) => s.exams || [])
    ),
  ];

  const studentTotalPages = Math.max(
    1,
    Math.ceil(
      filtStudents.length / ITEMS_PER_PAGE
    )
  );

  const paginatedStudents = filtStudents.slice(
    (studentPage - 1) * ITEMS_PER_PAGE,
    studentPage * ITEMS_PER_PAGE
  );
  const booksList = [
    {
      title: "Manthan 2025 Practice Guide",
      qty: 20,
      date: "Jan 2025",
      vendor: "Navneet Publications",
    },
    {
      title: "ICS Olympiad Workbook",
      qty: 15,
      date: "Feb 2025",
      vendor: "Target Publications",
    },
    {
      title: "Shabbas Practice Set Vol.2",
      qty: 15,
      date: "Mar 2025",
      vendor: "Navneet Publications",
    },
  ].slice(
    0,
    viewTeacher.booksPurchased > 0 ? 3 : 0
  );

  const bookTotalPages = Math.max(
    1,
    Math.ceil(
      booksList.length / ITEMS_PER_PAGE
    )
  );

  const paginatedBooks = booksList.slice(
    (bookPage - 1) * ITEMS_PER_PAGE,
    bookPage * ITEMS_PER_PAGE
  );
  const examRows = (viewTeacher.examNames || []).map((e) => ({
    name: e,
    students: myStudents.filter(
      (s) => (s.exams || []).includes(e)
    ).length,
    status: "active",
  }));
  const handleTabChange = (newTab) => {
    setTab(newTab);
    setQ("");
    setStudentPage(1);
    setBookPage(1);
  };

  const handleSearch = (value) => {
    setQ(value);
    setStudentPage(1);
  };

  const studentPages = Array.from(
    { length: studentTotalPages },
    (_, i) => i + 1
  );

  const bookPages = Array.from(
    { length: bookTotalPages },
    (_, i) => i + 1
  );

  const paginationBaseStyle = {
    height: 32,
    minWidth: 32,
    padding: "0 10px",
    borderRadius: 7,
    border: "1px solid #E2E8F0",
    background: "#FFFFFF",
    color: "#475569",
    fontSize: 11,
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    cursor: "pointer",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
  };

  const disabledPaginationStyle = {
    ...paginationBaseStyle,
    background: "#F8FAFC",
    border: "1px solid #E2E8F0",
    color: "#CBD5E1",
    cursor: "not-allowed",
  };

  const activePageStyle = {
    ...paginationBaseStyle,
    minWidth: 32,
    width: 32,
    padding: 0,
    background: "#2563EB",
    border: "1px solid #2563EB",
    color: "#FFFFFF",
    boxShadow: "0 1px 3px rgba(37,99,235,0.20)",
  };
  const handlePaginationMouseEnter = (e, disabled) => {
    if (disabled) return;

    e.currentTarget.style.background = "#EFF6FF";
    e.currentTarget.style.borderColor = "#60A5FA";
    e.currentTarget.style.color = "#2563EB";
  };

  const handlePaginationMouseLeave = (e, disabled) => {
    if (disabled) return;

    e.currentTarget.style.background = "#FFFFFF";
    e.currentTarget.style.borderColor = "#E2E8F0";
    e.currentTarget.style.color = "#475569";
  };

  return (
    <>
      <BC
        items={["Teachers", viewTeacher.name || "Teacher"]}
        onBack={onBack}
      />

      {detailLoading && (
        <div
          style={{
            marginBottom: 10,
            fontSize: 11,
            color: "var(--t3)",
          }}
        >
          Loading latest teacher details...
        </div>
      )}

      {detailError && (
        <div
          style={{
            marginBottom: 10,
            padding: "8px 10px",
            borderRadius: 7,
            background: "#FEF2F2",
            color: "#B91C1C",
            fontSize: 11,
          }}
        >
          {detailError}
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: 14,
          flexWrap: "wrap",
          alignItems: "flex-start",
        }}
      > <div style={{ flex: "0 0 258px" }}>
          {/* Teacher Profile */}
          <div
            className="card cp"
            style={{
              textAlign: "center",
              marginBottom: 12,
            }}
          >
            <div
              className="av"
              style={{
                width: 60,
                height: 60,
                margin: "0 auto 11px",
                fontSize: 20,
              }}
            >
              {viewTeacher.initials}
            </div>

            <div
              style={{
                fontWeight: 800,
                fontSize: 15,
              }}
            >
              {viewTeacher.name}
            </div>

            <div
              style={{
                fontSize: 12,
                color: "var(--t3)",
                marginTop: 2,
              }}
            >
              {viewTeacher.school}
            </div>

            <div style={{ marginTop: 9 }}>
              <Bdg
                type={
                  viewTeacher.status === "active"
                    ? "green"
                    : "yellow"
                }
                label={
                  viewTeacher.status === "active"
                    ? "Active"
                    : "Inactive"
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: 8,
                marginTop: 14,
              }}
            >
              <button
                className="btn btn-p"
                style={{ flex: 1 }}
                onClick={() => onEdit(viewTeacher)}
              >
                <I
                  n="edit"
                  s={12}
                  c="#fff"
                />
                Edit
              </button>

              <button
                className="btn btn-g"
                style={{ flex: 1 }}
              >
                <I
                  n="sms"
                  s={12}
                />
                Message
              </button>
            </div>
          </div>

          <div className="card cp">
            <div className="sec-tag">
              Quick Stats
            </div>

            <div
              className="g3"
              style={{ gap: 8 }}
            >
              {[
                {
                  l: "Students",
                  v: viewTeacher.studentCount,
                  ic: "student",
                  c: "#2563EB",
                  bg: "#EFF6FF",
                },
                {
                  l: "Books",
                  v: viewTeacher.booksPurchased,
                  ic: "book",
                  c: "#10B981",
                  bg: "#ECFDF5",
                },
              ].map((s) => (
                <div
                  key={s.l}
                  style={{
                    background: s.bg,
                    borderRadius: 7,
                    padding: "9px 6px",
                    textAlign: "center",
                  }}
                >
                  <I
                    n={s.ic}
                    s={15}
                    c={s.c}
                  />

                  <div
                    style={{
                      fontSize: 17,
                      fontWeight: 800,
                      color: s.c,
                      marginTop: 3,
                    }}
                  >
                    {s.v}
                  </div>

                  <div
                    style={{
                      fontSize: 9.5,
                      color: "var(--t3)",
                      marginTop: 1,
                    }}
                  >
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            minWidth: 280,
          }}
        >
          <div
            className="card"
            style={{
              overflow: "visible",
            }}
          >
            <div
              style={{
                padding: "14px 18px 0",
              }}
            >
              <div
                className="tabs-bar"
                style={{
                  marginBottom: 0,
                }}
              >
                {[
                  "students",
                  "books",
                  "details",
                ].map((t) => (
                  <button
                    key={t}
                    className={`tab-btn ${tab === t ? "on" : ""
                      }`}
                    onClick={() =>
                      handleTabChange(t)
                    }
                  >
                    {t.charAt(0).toUpperCase() +
                      t.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            <div
              style={{
                padding: "14px 18px",
              }}
            >
              {tab === "students" && (
                <>
                  <div
                    className="toolbar"
                    style={{
                      marginBottom: 12,
                    }}
                  >
                    <SB
                      value={q}
                      onChange={handleSearch}
                      placeholder="Search students…"
                    />
                  </div>

                  <div className="tw">
                    <table>
                      <thead>
                        <tr>
                          <th>Student Name</th>
                          <th>Class</th>
                          <th>Exams</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {paginatedStudents.length ===
                          0 ? (
                          <tr>
                            <td
                              colSpan={4}
                              style={{
                                textAlign:
                                  "center",
                                padding: "20px",
                                color:
                                  "var(--t3)",
                                fontSize: 12,
                              }}
                            >
                              No students found
                            </td>
                          </tr>
                        ) : (
                          paginatedStudents.map(
                            (s, i) => (
                              <tr key={s.id}>
                                <td>
                                  <div
                                    style={{
                                      display:
                                        "flex",
                                      alignItems:
                                        "center",
                                      gap: 7,
                                    }}
                                  >
                                    <div
                                      className="av"
                                      style={{
                                        width: 24,
                                        height: 24,
                                        fontSize: 9,
                                        background: `hsl(${i *
                                          55 +
                                          190
                                          },58%,52%)`,
                                      }}
                                    >
                                      {s.name?.[0]}
                                    </div>

                                    <span
                                      className="tdb"
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      {s.name}
                                    </span>
                                  </div>
                                </td>

                                <td>
                                  <Bdg
                                    type="blue"
                                    label={`C${s.class}`}
                                  />
                                </td>

                                <td>
                                  <ExamPills
                                    exams={s.exams}
                                  />
                                </td>

                                <td>
                                  <Bdg
                                    type={
                                      s.status ===
                                        "active"
                                        ? "green"
                                        : "yellow"
                                    }
                                    label={
                                      s.status ===
                                        "active"
                                        ? "Active"
                                        : "Dropped"
                                    }
                                  />
                                </td>
                              </tr>
                            )
                          )
                        )}
                      </tbody>
                    </table>

                    {filtStudents.length > 0 && (
                      <div
                        style={{
                          width: "100%",
                          marginTop: 14,
                          paddingTop: 12,
                          borderTop:
                            "1px solid #F1F5F9",
                          display: "flex",
                          alignItems: "center",
                          justifyContent:
                            "space-between",
                          gap: 12,
                          flexWrap: "nowrap",
                        }}
                      >

                        <div
                          style={{
                            flex: "0 0 auto",
                            fontSize: 11,
                            color: "#64748B",
                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          Showing{" "}
                          <span
                            style={{
                              margin: "0 4px",
                              fontWeight: 600,
                              color: "#334155",
                            }}
                          >
                            {(studentPage - 1) *
                              ITEMS_PER_PAGE +
                              1}
                          </span>
                          –
                          <span
                            style={{
                              margin: "0 4px",
                              fontWeight: 600,
                              color: "#334155",
                            }}
                          >
                            {Math.min(
                              studentPage *
                              ITEMS_PER_PAGE,
                              filtStudents.length
                            )}
                          </span>
                          of{" "}
                          <span
                            style={{
                              marginLeft: 4,
                              fontWeight: 600,
                              color: "#334155",
                            }}
                          >
                            {filtStudents.length}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent:
                              "flex-end",
                            gap: 5,
                            flex: "0 0 auto",
                            whiteSpace:
                              "nowrap",
                          }}
                        >
                          <button
                            type="button"
                            disabled={
                              studentPage === 1
                            }
                            onClick={() =>
                              setStudentPage(
                                (p) =>
                                  Math.max(
                                    1,
                                    p - 1
                                  )
                              )
                            }
                            onMouseEnter={(e) =>
                              handlePaginationMouseEnter(
                                e,
                                studentPage === 1
                              )
                            }
                            onMouseLeave={(e) =>
                              handlePaginationMouseLeave(
                                e,
                                studentPage === 1
                              )
                            }
                            style={
                              studentPage === 1
                                ? disabledPaginationStyle
                                : paginationBaseStyle
                            }
                          >
                            <span
                              style={{
                                fontSize: 15,
                                lineHeight: 1,
                              }}
                            >
                              ‹
                            </span>
                            Back
                          </button>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                            }}
                          >
                            {studentPages.map(
                              (page) => (
                                <button
                                  key={page}
                                  type="button"
                                  onClick={() =>
                                    setStudentPage(
                                      page
                                    )
                                  }
                                  style={
                                    studentPage ===
                                      page
                                      ? activePageStyle
                                      : paginationBaseStyle
                                  }
                                  onMouseEnter={(e) => {
                                    if (
                                      studentPage !==
                                      page
                                    ) {
                                      handlePaginationMouseEnter(
                                        e,
                                        false
                                      );
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (
                                      studentPage !==
                                      page
                                    ) {
                                      handlePaginationMouseLeave(
                                        e,
                                        false
                                      );
                                    }
                                  }}
                                >
                                  {page}
                                </button>
                              )
                            )}
                          </div>
                          <button
                            type="button"
                            disabled={
                              studentPage ===
                              studentTotalPages
                            }
                            onClick={() =>
                              setStudentPage(
                                (p) =>
                                  Math.min(
                                    studentTotalPages,
                                    p + 1
                                  )
                              )
                            }
                            onMouseEnter={(e) =>
                              handlePaginationMouseEnter(
                                e,
                                studentPage ===
                                studentTotalPages
                              )
                            }
                            onMouseLeave={(e) =>
                              handlePaginationMouseLeave(
                                e,
                                studentPage ===
                                studentTotalPages
                              )
                            }
                            style={
                              studentPage ===
                                studentTotalPages
                                ? disabledPaginationStyle
                                : paginationBaseStyle
                            }
                          >
                            Next
                            <span
                              style={{
                                fontSize: 15,
                                lineHeight: 1,
                              }}
                            >
                              ›
                            </span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}

              {tab === "books" && (
                <div className="tw">
                  <table>
                    <thead>
                      <tr>
                        <th>Book Title</th>
                        <th>Vendor</th>
                        <th>Qty</th>
                        <th>Date</th>
                      </tr>
                    </thead>

                    <tbody>
                      {paginatedBooks.length ===
                        0 ? (
                        <tr>
                          <td
                            colSpan={4}
                            style={{
                              textAlign:
                                "center",
                              padding: "20px",
                              color:
                                "var(--t3)",
                              fontSize: 12,
                            }}
                          >
                            No books recorded
                          </td>
                        </tr>
                      ) : (
                        paginatedBooks.map(
                          (b, i) => (
                            <tr key={i}>
                              <td
                                className="tdb"
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                {b.title}
                              </td>

                              <td
                                className="td2"
                                style={{
                                  fontSize: 11.5,
                                }}
                              >
                                {b.vendor}
                              </td>

                              <td
                                style={{
                                  fontWeight: 600,
                                }}
                              >
                                {b.qty}
                              </td>

                              <td
                                className="td2"
                                style={{
                                  fontSize: 11.5,
                                }}
                              >
                                {b.date}
                              </td>
                            </tr>
                          )
                        )
                      )}

                      {booksList.length > 0 && (
                        <tr
                          style={{
                            background:
                              "var(--bg)",
                          }}
                        >
                          <td
                            style={{
                              fontWeight: 700,
                              fontSize: 12,
                            }}
                            colSpan={2}
                          >
                            Total
                          </td>

                          <td
                            style={{
                              fontWeight: 700,
                              color: "var(--p)",
                            }}
                          >
                            {booksList.reduce(
                              (a, b) =>
                                a + b.qty,
                              0
                            )}
                          </td>

                          <td />
                        </tr>
                      )}
                    </tbody>
                  </table>
                  {booksList.length > 0 && (
                    <div
                      style={{
                        width: "100%",
                        marginTop: 14,
                        paddingTop: 12,
                        borderTop:
                          "1px solid #F1F5F9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent:
                          "space-between",
                        gap: 12,
                        flexWrap: "nowrap",
                      }}
                    >
                      <div
                        style={{
                          flex: "0 0 auto",
                          fontSize: 11,
                          color: "#64748B",
                          whiteSpace:
                            "nowrap",
                        }}
                      >
                        Showing{" "}
                        <span
                          style={{
                            margin: "0 4px",
                            fontWeight: 600,
                            color: "#334155",
                          }}
                        >
                          {(bookPage - 1) *
                            ITEMS_PER_PAGE +
                            1}
                        </span>
                        –
                        <span
                          style={{
                            margin: "0 4px",
                            fontWeight: 600,
                            color: "#334155",
                          }}
                        >
                          {Math.min(
                            bookPage *
                            ITEMS_PER_PAGE,
                            booksList.length
                          )}
                        </span>
                        of{" "}
                        <span
                          style={{
                            marginLeft: 4,
                            fontWeight: 600,
                            color: "#334155",
                          }}
                        >
                          {booksList.length}
                        </span>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent:
                            "flex-end",
                          gap: 5,
                          flex: "0 0 auto",
                          whiteSpace:
                            "nowrap",
                        }}
                      >
                        <button
                          type="button"
                          disabled={bookPage === 1}
                          onClick={() =>
                            setBookPage(
                              (p) =>
                                Math.max(
                                  1,
                                  p - 1
                                )
                            )
                          }
                          onMouseEnter={(e) =>
                            handlePaginationMouseEnter(
                              e,
                              bookPage === 1
                            )
                          }
                          onMouseLeave={(e) =>
                            handlePaginationMouseLeave(
                              e,
                              bookPage === 1
                            )
                          }
                          style={
                            bookPage === 1
                              ? disabledPaginationStyle
                              : paginationBaseStyle
                          }
                        >
                          <span
                            style={{
                              fontSize: 15,
                              lineHeight: 1,
                            }}
                          >
                            ‹
                          </span>
                          Back
                        </button>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          {bookPages.map(
                            (page) => (
                              <button
                                key={page}
                                type="button"
                                onClick={() =>
                                  setBookPage(
                                    page
                                  )
                                }
                                style={
                                  bookPage === page
                                    ? activePageStyle
                                    : paginationBaseStyle
                                }
                                onMouseEnter={(e) => {
                                  if (
                                    bookPage !==
                                    page
                                  ) {
                                    handlePaginationMouseEnter(
                                      e,
                                      false
                                    );
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (
                                    bookPage !==
                                    page
                                  ) {
                                    handlePaginationMouseLeave(
                                      e,
                                      false
                                    );
                                  }
                                }}
                              >
                                {page}
                              </button>
                            )
                          )}
                        </div>
                        <button
                          type="button"
                          disabled={
                            bookPage ===
                            bookTotalPages
                          }
                          onClick={() =>
                            setBookPage(
                              (p) =>
                                Math.min(
                                  bookTotalPages,
                                  p + 1
                                )
                            )
                          }
                          onMouseEnter={(e) =>
                            handlePaginationMouseEnter(
                              e,
                              bookPage ===
                              bookTotalPages
                            )
                          }
                          onMouseLeave={(e) =>
                            handlePaginationMouseLeave(
                              e,
                              bookPage ===
                              bookTotalPages
                            )
                          }
                          style={
                            bookPage ===
                              bookTotalPages
                              ? disabledPaginationStyle
                              : paginationBaseStyle
                          }
                        >
                          Next
                          <span
                            style={{
                              fontSize: 15,
                              lineHeight: 1,
                            }}
                          >
                            ›
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {tab === "details" && (
                <div
                  className="fgrid"
                  style={{ gap: 9 }}
                >
                  {[
                    [
                      "Mobile",
                      viewTeacher.mobile || "—",
                    ],
                    [
                      "Alternate Phone",
                      viewTeacher.alternatePhone || "—",
                    ],
                    [
                      "Pincode",
                      viewTeacher.pincode || "—",
                    ],
                    [
                      "Email",
                      viewTeacher.email || "—",
                    ],
                    [
                      "Address",
                      viewTeacher.address || "—",
                    ],
                    ["Status", viewTeacher.status],
                  ].map(([k, v]) => (
                    <div
                      key={k}
                      className="vf"
                    >
                      <div className="vfl">
                        {k}
                      </div>

                      <div
                        className="vfv"
                        style={{
                          fontSize: 12.5,
                        }}
                      >
                        {v}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}